import { render, staticRenderFns } from "./ModeratorCourses.vue?vue&type=template&id=3b4e6d7a&scoped=true"
import script from "./ModeratorCourses.vue?vue&type=script&lang=js"
export * from "./ModeratorCourses.vue?vue&type=script&lang=js"
import style0 from "./ModeratorCourses.vue?vue&type=style&index=0&id=3b4e6d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4e6d7a",
  null
  
)

export default component.exports